import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, NavigationExtras } from '@angular/router';
import { AuthService } from '../services/authenticate.service';

@Injectable()
export class PWDAuthGuard  {
    constructor(
        private authService: AuthService,
        private router: Router,
    ) { }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        try {
            const claims: any = this.authService.getToken();
            let hasAccess = false;
            if (claims != null) {
                hasAccess = true;
            }
            if (!hasAccess) {
                this.router.navigate(['/login']);
            }
            return hasAccess;
        } catch (error) {
            console.log(error);
            return false;
        }
    }
}
